<template>
  <div
    v-show="isLoaded"
    class="mAge-gate-section"
    v-observe-visibility="startAnimate"
  >
    <div class="mAge-gate-form">
      <img
        class="mLogo-age-gate"
        :class="{ animate: animate }"
        :src="`${pathpublic}Indio_Nueva_full.png`"
        alt="Logo de Indio"
        @load="preloadImages"
        width="850"
        height="850"
      />
      <p class="enter-birthday" :class="{ animate: animate }">
        Ingresa tu fecha de nacimiento
      </p>

      <div
        class="mform-row"
        :class="{ hasError: showWarning, animate: animate }"
      >
        <input
          class="bold"
          ref="day"
          type="tel"
          maxlength="2"
          placeholder="DD"
          v-on:keyup="focusNextSibling($event)"
          v-model="day"
        />
        <input
          class="bold"
          ref="month"
          type="tel"
          maxlength="2"
          placeholder="MM"
          v-on:keyup="focusNextSibling($event)"
          v-model="month"
        />
        <input
          class="bold"
          ref="year"
          type="tel"
          maxlength="4"
          placeholder="AAAA"
          v-on:keyup="focusNextSibling($event)"
          v-model="year"
        />
        <div @click="normalLogin" :class="{ animate: animate }" class="mLogin">
          <span>Entrar</span>
        </div>
      </div>

      <div
        class="mFacebook-login"
        :class="{ animate: animate }"
        v-if="!showWarning"
      >
        <p class="enter-with-facebook">O si prefieres, entra con</p>
        <FacebookButton
          v-on:fbLogin="fbLogin"
          v-on:noBirthdayInFacebook="noBirthdayInFacebook"
          isForResponsive="desktop"
        />
      </div>
      <div
        class="mFacebook-login"
        :class="{ animate: animate }"
        v-if="showWarning"
      >
        <p class="enter-with-facebook">
          Debes ser mayor de edad para navegar este sitio
        </p>
      </div>
    </div>
    <div class="mAge-gate-footer-desktop" :class="{ animate: animate }">
      <h4
        class="privacy clickable"
        @click="
          footerGA4Click('click', 'terminos y condiciones', 'footer') &
            $router.push('/tycos')
        "
      >
        Términos y Condiciones
      </h4>
      <span class="privacy bar">|</span>
      <h4
        class="privacy clickable"
        @click="
          footerGA4Click('click', 'aviso de privacidad', 'footer') &
            $router.push('/politics')
        "
      >
        Aviso de Privacidad
      </h4>
      <span class="privacy bar">|</span>
      <h4
        class="privacy clickable"
        @click="
          footerGA4Click('click', 'politica de cookies', 'footer') &
            $router.push('/cookies')
        "
      >
        Política de Cookies
      </h4>
      <span class="privacy bar">|</span>
      <h4 class="privacy desktop nohover">Evita el Exceso</h4>
      <div class="social-icons">
        <a
          class=""
          target="_blank"
          href="https://www.facebook.com/cervezaindio/"
          @click="
            socialClick('Facebook', 'Interaction') &
              socialGA4Click('click', 'redes sociales :: facebook', 'footer')
          "
        >
          <img :src="fbIconImage" alt="Facebook" width="43" height="42" />
        </a>
        <a
          class=""
          target="_blank"
          href="https://www.instagram.com/cervezaindio/"
          @click="
            socialClick('Instagram', 'Interaction') &
              socialGA4Click('click', 'redes sociales :: instagram', 'footer')
          "
        >
          <img :src="inIconImage" alt="Instagram" width="43" height="42" />
        </a>
        <a
          class=""
          target="_blank"
          href="https://twitter.com/cervezaindio"
          @click="
            socialClick('Twitter', 'Interaction') &
              socialGA4Click('click', 'redes sociales :: twitter', 'footer')
          "
        >
          <img :src="twIconImage" alt="Twitter" width="43" height="42" />
        </a>
        <a
          class=""
          target="_blank"
          href="https://www.youtube.com/user/cervezaindio"
          @click="
            socialClick('Youtube', 'Interaction') &
              socialGA4Click('click', 'redes sociales :: youtube', 'footer')
          "
        >
          <img :src="ytIconImage" alt="Youtube" width="43" height="42" />
        </a>
      </div>
    </div>
    <div class="mAge-gate-footer-mobile" :class="{ animate: animate }">
      <div class="privacy-second">
        <h4
          class="privacy clickable"
          @click="
            footerGA4Click('click', 'terminos y condiciones', 'footer') &
              $router.push('/tycos')
          "
        >
          Términos y Condiciones
        </h4>
        <span class="privacy bar">|</span>
        <h4
          class="privacy clickable"
          @click="
            footerGA4Click('click', 'aviso de privacidad', 'footer') &
              $router.push('/politics')
          "
        >
          Aviso de Privacidad
        </h4>
      </div>
      <div class="privacy-second">
        <h4
          class="privacy clickable"
          @click="
            footerGA4Click('click', 'politica de cookies', 'footer') &
              $router.push('/cookies')
          "
        >
          Política de Cookies
        </h4>
        <span class="privacy bar">|</span>
        <h4 class="privacy clickable">Evita el Exceso</h4>
      </div>
      <div class="social-icons">
        <a
          class=""
          target="_blank"
          href="https://www.facebook.com/cervezaindio/"
          @click="
            socialClick('Facebook', 'Interaction') &
              socialGA4Click('click', 'redes sociales :: facebook', 'footer')
          "
        >
          <img :src="fbIconImage" alt="Facebook" width="43" height="42" />
        </a>
        <a
          class=""
          target="_blank"
          href="https://www.instagram.com/cervezaindio/"
          @click="
            socialClick('Instagram', 'Interaction') &
              socialGA4Click('click', 'redes sociales :: instagram', 'footer')
          "
        >
          <img :src="inIconImage" alt="Instagram" width="43" height="42" />
        </a>
        <a
          class=""
          target="_blank"
          href="https://twitter.com/cervezaindio"
          @click="
            socialClick('Twitter', 'Interaction') &
              socialGA4Click('click', 'redes sociales :: twitter', 'footer')
          "
        >
          <img :src="twIconImage" alt="Twitter" width="43" height="42" />
        </a>
        <a
          class=""
          target="_blank"
          href="https://www.youtube.com/user/cervezaindio"
          @click="
            socialClick('Youtube', 'Interaction') &
              socialGA4Click('click', 'redes sociales :: youtube', 'footer')
          "
        >
          <img :src="ytIconImage" alt="Youtube" width="43" height="42" />
        </a>
      </div>
    </div>
    <Modal
      v-if="showModal"
      v-bind:wichModal="wichModal"
      @close="showModal = false"
    />
    <ModalCookies
      v-if="showModalC"
      v-bind:wichModalC="wichModalC"
      @close="showModalC = false"
    />
  </div>
</template>

<script>
//import Moment from "moment";

import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import axios from "axios";
import Modal from "@/components/Modal";
import ModalCookies from "@/components/ModalCookies";
import FacebookButton from "@/components/FacebookButton";

import fbIcon from "@/assets/fbIcon.png";
import twIcon from "@/assets/twIcon.png";
import ytIcon from "@/assets/ytIcon.png";
import inIcon from "@/assets/instaIcon.png";

//import logo from "../../public/Indio_Nueva_full.png";

import tagFunctions from "@/utils/tagFunctions.js";

import botella from "@/assets/indio_botella.png";
import redbox from "@/assets/CUADRO-ROJO-02.png";
import header from "@/assets/header.jpg";
import history1 from "@/assets/history1.png";
import history2 from "@/assets/history2.png";
import emperor from "@/assets/Closeup Emperador-02.png";

import { differenceInYears, format, parse } from "date-fns";

export default {
  name: "AgeGate",
  components: {
    FacebookButton,
    Modal,
    ModalCookies,
  },
  data() {
    return {
      day: undefined,
      month: undefined,
      year: undefined,
      showWarning: false,
      showModal: false,
      wichModal: "tycos",
      showModalC: false,
      wichModalC: "tycos",
      response: undefined,
      pathpublic: process.env.BASE_URL,
      fbIconImage: fbIcon,
      twIconImage: twIcon,
      ytIconImage: ytIcon,
      inIconImage: inIcon,
      window: {
        width: 0,
        height: 0,
      },
      animate: false,
      refererPath: '',
      refererParams: '',
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible) {
      if (isVisible) {
        this.animate = true;
      }
    },
    ...mapActions({
      setAgeGateTokenAction: "setAgeGateToken",
    }),
    socialClick(socialNetwork, action) {
      tagFunctions.evSocialNetworkPush(socialNetwork, action);
    },
    socialGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section);
    },
    form_interactionGA4Click(name, action) {
      tagFunctions.form_interactionPush(name, action);
    },
    form_sendGA4Click(name, element) {
      tagFunctions.form_sendPush(name, element);
    },
    loginFBGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section);
    },
    methodGA4Click(method) {
      tagFunctions.methodPush(method);
    },
    footerGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section);
    },
    attemptAgeGate() {
      tagFunctions.evAgeGatePush("Intento");
    },
    passAgeGate() {
      tagFunctions.evAgeGatePush("Exito");
    },
    failAgeGate(errorMessage) {
      tagFunctions.evAgeGatePush("Error", errorMessage);
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    noBirthdayInFacebook() {
      this.failAgeGate("La fecha de nacimiento no está disponible en Facebook");
      this.showWarning = true;
    },
    fbLogin(response) {
      console.log("🚀 ~ fbLogin ~ response:", response)
      this.attemptAgeGate();
      this.loginFBGA4Click("login", "facebook", "login");
      // console.log(response);
      // const bDay = parse(`${response.birthday}`, "MM/dd/yyyy", new Date());
      //const bDay = Moment(`${response.birthday}`, "MM/DD/YYYY");
      // const today = new Date();
      //const today = Moment();
      const minAge = response.age_range.min
      //const age = today.diff(bDay, "years");
      window.sessionStorage.setItem("ageUser", minAge);
      window.sessionStorage.setItem("ageUserBirthYear", minAge);
      //window.sessionStorage.setItem('ageUserBirthYear', bDay.format('YY'))
      if (isNaN(minAge) || minAge < 18) {
        console.log("🚀 ~ fbLogin ~ minAge:", minAge)
        this.showWarning = true;
        this.failAgeGate("El usuario es menor de edad");
        this.loginFBGA4Click("login", "facebook", "login");
      } else {
        setTimeout(() => {
          axios
            .get(
              `https://cuamoc.xeerpa.com:8443/discoveruser?clientId=5f9926bc3b9e6e12501ce314&clientPwd=RNmB13d1hT&appId=60c9aef24708290e389afeb7&socialNetwork=FB&userId=${response.authResponse.userID}&userToken=${response.authResponse.accessToken}`
            )
            .then((axiosResponse) => {
              this.response = axiosResponse;
              if(axiosResponse.status == 200){
                setTimeout(() => {
              
                window.sessionStorage.setItem(
                "agegate_indio_convocatoria",
                minAge
              );
                this.setAgeGateTokenAction(true);
                window.sessionStorage.setItem("ageGateToken", true);
                window.sessionStorage.setItem("network", "Facebook");
             
                let hasher = function(key, value) {
                  let digest = async ({ algorithm = "SHA-256", message }) =>
                    Array.prototype.map
                      .call(
                        new Uint8Array(
                          await crypto.subtle.digest(
                            algorithm,
                            new TextEncoder().encode(message)
                          )
                        ),
                        (x) => ("0" + x.toString(16)).slice(-2)
                      )
                      .join("");

                  digest({ message: value }).then((hash) => {
                    /*       Cookies.set(key, hash, {
                      expires: 1
                    }); */
                    window.sessionStorage.setItem(key, hash);
                  });
                };
                hasher("userId", response.email);
                this.passAgeGate();
                this.methodGA4Click("facebook");
                if (this.refererPath.includes("convocatoria")) {
                  location.href =
                    location.origin + this.refererPath + this.refererParams;
                  return true;
                }
              }, 200);
              }
      
            })
            .catch((e) => {
              this.errors.push(e);
            });
        }, 100);
      }
    },
    popUpModal(modalType) {
      this.showModal = true;
      this.wichModal = modalType;
    },
    popUpModalC(modalTypeC) {
      this.showModalC = true;
      this.wichModalC = modalTypeC;
    },
    hideWarning() {
      this.showWarning = false;
    },
    normalLogin() {
      this.attemptAgeGate();
      const { day, month, year } = this;
      if (day && day !== "" && month && month !== "" && year && year !== "") {
        //const bDay = Moment(`${day}/${month}/${year}`, "DD/MM/YYYY");
        const bDay = parse(`${day}/${month}/${year}`, "dd/MM/yyyy", new Date());
        window.localStorage.setItem("date", `${day}/${month}/${year}`);
        //const today = Moment();
        const today = new Date();
        /*         const ageYear =
          Number(bDay.format("YYYY")) > Number(today.format("YYYY")); */
        const ageYear =
          Number(format(bDay, "yyyy")) > Number(format(today, "yyyy"));
        //console.log(ageYear);

        //const age = today.diff(bDay, "years", false);
        const age = differenceInYears(today, bDay);

        window.sessionStorage.setItem("ageUser", age);
        window.sessionStorage.setItem("ageUserBirthYear", format(bDay, "yyyy"));
        this.form_interactionGA4Click(
          window.localStorage.getItem("date"),
          "complete"
        );
        //console.log(age);
        if ((isNaN(age) || age < 18) && !ageYear) {
          this.showWarning = true;
          this.failAgeGate("El usuario es menor de edad");
          this.form_sendGA4Click("entrar", "entrar");
        } else {
          setTimeout(() => {
          
            window.sessionStorage.setItem(
                "agegate_indio_convocatoria",
                format(bDay, "dd-MM-yyyy")
              );
            this.setAgeGateTokenAction(true);
            window.sessionStorage.setItem("ageGateToken", true);
            window.sessionStorage.setItem("network", "Normal");
            this.passAgeGate();
            this.form_sendGA4Click("entrar", "entrar");
            this.methodGA4Click("normal");
            if (this.refererPath.includes("convocatoria")) {
              location.href =
                location.origin + this.refererPath + this.refererParams;
              return true;
            }
          }, 100);
        }
      }
    },
    focusNextSibling(event) {
      const element = event.target;
      if (
        element &&
        element.value &&
        element.value.length === event.target.maxLength
      ) {
        event.target.nextElementSibling.focus();
      }
    },
    preloadImages() {
      new Image().src = botella;
      new Image().src = header;
      new Image().src = history1;
      new Image().src = history2;
      new Image().src = redbox;
      new Image().src = emperor;
    },
  },
  mounted() {
    //const refererUrl = new URL(document.referrer);
    //this.refererPath = refererUrl.pathname;
    //this.refererParams = refererUrl.search;
    this.$nextTick(() => {});
    this.$router.beforeEach((to, from, next) => {
      if (
        to.path == "/politics" ||
        to.path == "/cookies" ||
        to.path == "/tycos"
      ) {
        next();
        location.reload();
      }
    });
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/agegatem.scss";
</style>
